export const translations = {
  en: {
    nav: {
      starterKit: "Starter Kit",
      discover: "Discover",
      faq: "FAQ",
      contact: "Contact",
    },
    hero: {
      overline: "Independent Eliora Longevity Distributor — Immunotec",
      title: "The Art of Longevity",
      subtitle:
        "Science-backed vitality, sourced from nature. Two paths — one destination: a longer, more vibrant life.",
      ctaInsider: "I know Immunotec — Buy Starter Kit",
      ctaInsiderNote: "(up to -45% off on all purchases)",
      ctaExplorer: "New here — Discover the Science",
    },
    starter: {
      overline: "For Loyal Customers",
      title: "Already love Immunotec? Get more for less.",
      body:
        "Our Starter Kit unlocks the best access to the products you already trust — Immunocal, Immunocal Platinum, Immunocal Sport, Knutric+ and more — at the most competitive distributor pricing.",
      bullets: [
        "Up to 45% off retail prices",
        "Curated kit with bestsellers",
        "Personal advisor + monthly perks",
        "Free shipping on your first order",
      ],
      cta: "Buy the Starter Kit",
      note: "Activated as Independent Associate. No hidden fees.",
    },
    explorer: {
      overline: "New to Immunotec?",
      title: "Begin with the science of cellular nourishment.",
      body:
        "Immunotec products are crafted around bioactive proteins, balanced nutrition and clinical research. Explore the essentials, then let us tailor a plan for you.",
      products: [
        {
          name: "Immunocal",
          desc: "Bioactive whey protein for natural glutathione support.",
        },
        {
          name: "Immunocal Platinum",
          desc: "Advanced formula for adults 50+ with cytokine balance.",
        },
        {
          name: "Immunocal Sport",
          desc: "Bioactive whey + Nitro Boost for muscle and recovery.",
        },
        {
          name: "Xtra Energy",
          desc: "Clean energy & focus, no jitters, plant-derived caffeine.",
        },
      ],
      formTitle: "Request a personalized wellness plan",
      formBody:
        "Tell us a little about you. We'll send a tailored recommendation within 24 hours.",
      fields: {
        name: "Full name",
        email: "Email",
        phone: "Phone (optional)",
        message: "What are your wellness goals? (optional)",
      },
      submit: "Get More Info",
      submitting: "Sending…",
      success: "Thank you — we'll be in touch within 24 hours.",
      error: "Something went wrong. Please try again or message us on WhatsApp.",
      orWhatsapp: "Or chat with us on WhatsApp",
      productsOverline: "Immunotec Catalog",
      productsTitle: "The complete Immunotec collection",
      productsBody:
        "Enjoying physical, emotional and spiritual wellbeing is both a privilege and an essential need in this post-pandemic era. Knowing and feeling that your body is receiving the right nutrients to stay healthy, strong and protected is fundamental to a truly integrated wellness life.",
      productBuy: "Buy on Immunotec",
      seeAllProducts: "See all products",
    },
    quiz: {
      heroOverline: "Your complimentary 3-month protocol",
      heroTitle: "Take the Eliora Wellness Quiz — get your free protocol",
      heroBody:
        "Answer 10 simple questions and receive a complimentary, personalized 3-month Immunotec protocol — delivered as a downloadable infographic, by email and WhatsApp. 100% free.",
      heroBadge: "Free · No cost",
      heroCta: "Start my free protocol",
      stepOfTotal: (i, n) => `Question ${i} of ${n}`,
      profileTitle: "Almost there — just your contact details",
      profileBody:
        "So we can send your personalized protocol by email and WhatsApp.",
      profileName: "Full name",
      profileEmail: "Email",
      profilePhone: "WhatsApp number (with country code)",
      next: "Next",
      back: "Back",
      submit: "Generate my protocol",
      loadingTitle: "Crafting your protocol…",
      loadingBody: "Analyzing your answers and curating the right products.",
      errorTitle: "Something went wrong",
      errorBody: "Please try again or chat with us on WhatsApp.",
      retry: "Try again",
    },
    protocol: {
      headline: (name) => `Your 3-month Eliora Longevity Protocol, ${name}`,
      freeBadge: "Complimentary protocol",
      sentBanner:
        "✓ We've sent a copy to your email and opened WhatsApp so you can save it to your phone. Your advisor has also been notified.",
      takeNoteTitle: "Note these products",
      takeNoteBody:
        "Save the names below — when you click below, you'll be redirected to Immunotec to purchase them.",
      pricingTitle: "Two ways to buy",
      pricingOption1Label: "1 month — public price",
      pricingOption1Note: "Try the protocol for one month at standard price.",
      pricingOption2Label: "3-month scheduled order — 25% off",
      pricingOption2Note:
        "Lock in 3 months of your protocol and save 25% on every purchase, automatically delivered.",
      keyConcerns: "Key focus areas",
      monthLabel: "Month",
      products: "Recommended products",
      dailyRoutine: "Daily routine",
      lifestyle: "Lifestyle",
      closing: "A word from your advisor",
      downloadJpg: "Download JPG",
      downloadPdf: "Download PDF",
      buyProducts: "Buy my products on Immunotec",
      disclaimer:
        "This is nutritional / lifestyle guidance, not medical advice. Consult your physician before starting any supplement.",
    },
    social: {
      overline: "Lives Transformed",
      title: "Vitality that lasts a lifetime.",
      quote:
        "After three months on the Starter Kit my energy returned — I'm walking five kilometers a day at 67. Eliora made it effortless.",
      author: "— Marta R., Aguascalientes",
    },
    faq: {
      overline: "Questions",
      title: "Everything you need to know",
      items: [
        {
          q: "Is Eliora Longevity an official Immunotec store?",
          a: "We are independent Immunotec Associates. All products are 100% authentic and sourced directly from Immunotec; the brand is owned by Immunotec Inc.",
        },
        {
          q: "What does the Starter Kit include?",
          a: "A curated selection of Immunotec bestsellers plus your Independent Associate activation, a personal advisor and a private welcome session.",
        },
        {
          q: "How much can I save?",
          a: "Most clients save 25–45% on every order, and unlock additional rewards through monthly loyalty perks.",
        },
        {
          q: "Do you ship outside Mexico?",
          a: "Yes — Immunotec ships to North America, parts of Europe and Latin America. Contact us to confirm availability for your country.",
        },
      ],
    },
    footer: {
      tagline: "Science of longevity. Service of trust.",
      disclaimer:
        "Eliora Longevity is an Independent Immunotec Associate. Not officially affiliated with Immunotec Inc. corporate. Statements have not been evaluated by the FDA. Products are not intended to diagnose, treat, cure or prevent any disease.",
      rights: "All rights reserved.",
    },
    whatsapp: "Chat with us",
  },

  es: {
    nav: {
      starterKit: "Kit de Inicio",
      discover: "Descubre",
      faq: "Preguntas",
      contact: "Contacto",
    },
    hero: {
      overline: "Distribuidor Independiente Eliora Longevity — Immunotec",
      title: "El Arte de la Longevidad",
      subtitle:
        "Vitalidad con respaldo científico, inspirada en la naturaleza. Dos caminos, un destino: una vida más larga y vibrante.",
      ctaInsider: "Conozco Immunotec — Comprar Kit de Inicio",
      ctaInsiderNote: "(hasta -45% de descuento)",
      ctaExplorer: "Soy nuevo — Descubrir la Ciencia",
    },
    starter: {
      overline: "Para clientes leales",
      title: "¿Ya amas Immunotec? Obtén más por menos.",
      body:
        "Nuestro Kit de Inicio te da el mejor acceso a los productos que ya conoces — Immunocal, Immunocal Platinum, Immunocal Sport, Knutric+ y más — al precio más competitivo de distribuidor.",
      bullets: [
        "Hasta 45% de descuento sobre precio público",
        "Kit curado con los más vendidos",
        "Asesor personal y beneficios mensuales",
        "Envío gratis en tu primer pedido",
      ],
      cta: "Comprar el Kit de Inicio",
      note: "Activación como Asociado Independiente. Sin cargos ocultos.",
    },
    explorer: {
      overline: "¿Nuevo en Immunotec?",
      title: "Comienza con la ciencia de la nutrición celular.",
      body:
        "Los productos Immunotec se construyen alrededor de proteínas bioactivas, nutrición balanceada e investigación clínica. Explora lo esencial y déjanos diseñar un plan a tu medida.",
      products: [
        {
          name: "Immunocal",
          desc: "Proteína de suero bioactiva para soporte natural de glutatión.",
        },
        {
          name: "Immunocal Platinum",
          desc: "Fórmula avanzada para adultos 50+ con balance de citoquinas.",
        },
        {
          name: "Immunocal Sport",
          desc: "Suero bioactivo + Nitro Boost para músculo y recuperación.",
        },
        {
          name: "Xtra Energy",
          desc: "Energía y enfoque sin nervios, cafeína de origen vegetal.",
        },
      ],
      formTitle: "Solicita tu plan de bienestar personalizado",
      formBody:
        "Cuéntanos un poco sobre ti. Te enviaremos una recomendación a medida en menos de 24 horas.",
      fields: {
        name: "Nombre completo",
        email: "Correo electrónico",
        phone: "Teléfono (opcional)",
        message: "¿Cuáles son tus objetivos de bienestar? (opcional)",
      },
      submit: "Quiero más info",
      submitting: "Enviando…",
      success: "Gracias — te contactaremos en menos de 24 horas.",
      error: "Algo salió mal. Inténtalo de nuevo o escríbenos por WhatsApp.",
      orWhatsapp: "O escríbenos por WhatsApp",
      productsOverline: "Catálogo Immunotec",
      productsTitle: "La colección completa Immunotec",
      productsBody:
        "Poder gozar de bienestar físico, emocional y espiritual es un privilegio y una necesidad imperante en esta era post-pandemia. El saber y sentir que tu cuerpo está recibiendo los nutrientes adecuados para mantenerse sano, fuerte y protegido es fundamental para disfrutar de una vida wellness integral.",
      productBuy: "Comprar en Immunotec",
      seeAllProducts: "Ver todos los productos",
    },
    quiz: {
      heroOverline: "Tu protocolo de cortesía de 3 meses",
      heroTitle: "Toma el Eliora Wellness Quiz — obtén tu protocolo gratuito",
      heroBody:
        "Responde 10 preguntas simples y recibe un protocolo Immunotec personalizado de 3 meses, totalmente gratuito — entregado como infografía descargable, por email y WhatsApp. Sin costo, sin compromiso.",
      heroBadge: "Gratis · Sin costo",
      heroCta: "Obtener mi protocolo gratuito",
      stepOfTotal: (i, n) => `Pregunta ${i} de ${n}`,
      profileTitle: "Casi listo, solo necesitamos tus datos",
      profileBody:
        "Para enviarte tu protocolo personalizado por email y WhatsApp.",
      profileName: "Nombre completo",
      profileEmail: "Correo electrónico",
      profilePhone: "WhatsApp (con código de país)",
      next: "Siguiente",
      back: "Atrás",
      submit: "Generar mi protocolo",
      loadingTitle: "Diseñando tu protocolo…",
      loadingBody:
        "Analizando tus respuestas y eligiendo los productos correctos.",
      errorTitle: "Algo salió mal",
      errorBody:
        "Inténtalo de nuevo o escríbenos por WhatsApp para ayudarte.",
      retry: "Reintentar",
    },
    protocol: {
      headline: (name) => `Tu Protocolo Eliora Longevity de 3 meses, ${name}`,
      freeBadge: "Protocolo de cortesía",
      sentBanner:
        "✓ Te enviamos una copia a tu correo y abrimos WhatsApp para que guardes el protocolo en tu teléfono. Tu asesora también fue notificada.",
      takeNoteTitle: "Toma nota de estos productos",
      takeNoteBody:
        "Guarda los nombres de abajo — al presionar el botón te llevaremos a Immunotec para adquirirlos.",
      pricingTitle: "Dos formas de comprar",
      pricingOption1Label: "1 mes a precio público",
      pricingOption1Note:
        "Prueba el protocolo durante un mes al precio normal.",
      pricingOption2Label: "Compra programada 3 meses — 25% de descuento",
      pricingOption2Note:
        "Asegura 3 meses de tu protocolo y ahorra 25% en cada compra, enviada automáticamente.",
      keyConcerns: "Áreas clave de enfoque",
      monthLabel: "Mes",
      products: "Productos recomendados",
      dailyRoutine: "Rutina diaria",
      lifestyle: "Estilo de vida",
      closing: "Una nota de tu asesora",
      downloadJpg: "Descargar JPG",
      downloadPdf: "Descargar PDF",
      buyProducts: "Adquirir mis productos en Immunotec",
      disclaimer:
        "Esto es orientación nutricional y de estilo de vida, no consejo médico. Consulta a tu médico antes de comenzar cualquier suplemento.",
    },
    social: {
      overline: "Vidas transformadas",
      title: "Vitalidad que dura toda la vida.",
      quote:
        "Después de tres meses con el Kit de Inicio recuperé mi energía — camino cinco kilómetros al día a los 67. Eliora lo hizo sencillo.",
      author: "— Marta R., Aguascalientes",
    },
    faq: {
      overline: "Preguntas",
      title: "Todo lo que necesitas saber",
      items: [
        {
          q: "¿Eliora Longevity es una tienda oficial de Immunotec?",
          a: "Somos Asociados Independientes de Immunotec. Todos los productos son 100% auténticos y provienen directamente de Immunotec; la marca pertenece a Immunotec Inc.",
        },
        {
          q: "¿Qué incluye el Kit de Inicio?",
          a: "Una selección curada de los más vendidos de Immunotec, tu activación como Asociado Independiente, un asesor personal y una sesión privada de bienvenida.",
        },
        {
          q: "¿Cuánto puedo ahorrar?",
          a: "La mayoría de nuestros clientes ahorra entre 25% y 45% en cada pedido, y obtiene beneficios adicionales con el programa de lealtad mensual.",
        },
        {
          q: "¿Envían fuera de México?",
          a: "Sí — Immunotec envía a Norteamérica, partes de Europa y Latinoamérica. Contáctanos para confirmar la disponibilidad en tu país.",
        },
      ],
    },
    footer: {
      tagline: "Ciencia de la longevidad. Servicio de confianza.",
      disclaimer:
        "Eliora Longevity es Asociado Independiente Immunotec. No está oficialmente afiliado a Immunotec Inc. corporativo. Estas declaraciones no han sido evaluadas por autoridades sanitarias. Los productos no están destinados a diagnosticar, tratar, curar o prevenir ninguna enfermedad.",
      rights: "Todos los derechos reservados.",
    },
    whatsapp: "Chatea con nosotros",
  },
};

export const WHATSAPP_NUMBER = "524491958252";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}`;
export const STARTER_KIT_URL =
  "https://www.immunotec.com/elioralongevity/enrollment/packs";

export const PRODUCTS_BUY_URL =
  "https://www.immunotec.com/es-MX/elioralongevity/products";
